import request from '@/utils/request'
export function searchInfo(data){
    return request.get(`/api/v1/admin/form/${data}`)
}
//报名列表
export function getEnrollList(page,pagesize){
    return request.get(`/api/v1/form/all?page=${page}&page_long=${pagesize}`)
}